// known-secret-values-deep-display-redaction.ts — phase 04a (spec V2 §4.2, I4a).
//
// Sink HIỂN THỊ (status text/`--json`/HTML, sổ quyết định) dựng từ một object
// dữ liệu: che known-values ở MỌI chuỗi lồng trong object trước khi render ⇒
// một chỗ phủ cả ba dạng output và `--watch`. Khác journal
// (journal-delta-known-secret-text-fields.ts): ở đây không có gì để replay,
// che cả field id cũng vô hại. `values` rỗng ⇒ trả CHÍNH object (I1).
import { makeKnownValuesRedactor } from "./secret-redactor.js";

function redactDeep(value: unknown, redact: (text: string) => string): unknown {
  if (typeof value === "string") return redact(value);
  if (Array.isArray(value)) return value.map((v) => redactDeep(v, redact));
  if (value === null || typeof value !== "object" || value instanceof Date) return value;
  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>).map(([k, v]) => [k, redactDeep(v, redact)]),
  );
}

export function redactKnownValuesDeep<T>(value: T, values: readonly string[]): T {
  if (values.length === 0) return value;
  return redactDeep(value, makeKnownValuesRedactor(values)) as T;
}
